import type { CopilotScope } from "@productlane/lib/src/ai"

// One shared object, so the toggle in the detail bar and the panel beside the
// page resolve to the same copilot state key.
export const AGENT_COPILOT_SCOPE: CopilotScope = { kind: "agent" }
